export const textLinkStyles = `
  font-weight: 600;
`;
